/**
 * Qué app arranca: la del CHOFER (liviana) o la de la OFICINA (9-oct-2026).
 *
 * Hasta ese día había un solo paquete: el teléfono del chofer bajaba y cargaba en memoria la app de oficina entera
 * (mapas, tableros, grillas: 3,6 MB de código) para mostrar una pantalla con un botón. En un teléfono con poca memoria
 * eso es lo que hace que el sistema cierre el navegador cuando se abre la cámara. Ahora `index.js` decide ANTES de
 * cargar nada y trae un paquete o el otro.
 *
 * La regla, PURA: es la app del chofer si quien tiene la sesión guardada es un chofer, o si la dirección es la de la
 * app del chofer o la de activar la cuenta. Todo lo demás es la oficina, exactamente como siempre.
 *
 * Ojo con «/choferes» (la nómina, de la oficina): empieza igual que «/chofer» y NO es la app del chofer.
 */
export const ROLES_CHOFER = ["chofer_propio", "chofer_externo"];

/** PURA. ¿Esa dirección es de la app del chofer? */
export function esRutaDeChofer(ruta) {
  const r = String(ruta || "");
  return r === "/chofer" || r.startsWith("/chofer/") || r.startsWith("/activar/");
}

/** PURA. `"chofer"` o `"oficina"`. */
export function cualApp({ ruta, rol } = {}) {
  if (ROLES_CHOFER.includes(rol)) return "chofer";
  return esRutaDeChofer(ruta) ? "chofer" : "oficina";
}

/** El rol de la sesión guardada en este navegador, o null. Nunca levanta. */
export function rolGuardado() {
  try {
    if (!localStorage.getItem("qb_token")) return null;
    const u = JSON.parse(localStorage.getItem("qb_user") || "null");
    return (u && typeof u.rol === "string") ? u.rol : null;
  } catch { return null; }
}
